import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import {  filterQuestionsByGrade, getData} from '../myComponents/QuranApi';
import Loading from '../Loading';
import { BsBack } from "react-icons/bs";
import { useNavigate } from 'react-router-dom';

const Questions = () => {
  const navigate = useNavigate();
  const [takens, setTakens] = useState([]);
  const [numShow, setNumShow] = useState(false);
  const [luckyNumber1, setLuckyNumber1] = useState(localStorage?.getItem("q1") || null);
  const [luckyNumber2, setLuckyNumber2] = useState(localStorage?.getItem("q1") || null);
  const [loading, setLoading] = useState(false);
  const [spinning, setSpinning] = useState(false);
  
  const gofi = localStorage?.getItem("gofi");
  const grade = localStorage?.getItem("grade");


 //const gofi = "balaigen";
  //const grade = 1;


  console.log(grade, gofi)

  const [question1, setQuestion1] = useState({});
  const [question2, setQuestion2] = useState({});

  const takenQuestions = ["2_6", "2_7", "2_8"];


  const generateRandomNumbers = () => {
    setNumShow(false);
    setSpinning(true);
    const filteredQuestions = filterQuestionsByGrade(grade, gofi);
    let filter = []
    for (let i = 0; i < filteredQuestions.length; i++) {
      if (!takenQuestions.includes(filteredQuestions[i].sv)) {
        filter.push(filteredQuestions[i].vid)
      }
    }
  
    const randomIndex1 = Math.floor(Math.random() * filter.length);
    let randomIndex2 = Math.floor(Math.random() * filter.length);
    do {
      randomIndex2 = Math.floor(Math.random() * filter.length);
    } while (randomIndex2 === randomIndex1);
  
    const randomNumber1 = filter[randomIndex1];
    const randomNumber2 = filter[randomIndex2];
  
    setLuckyNumber1(randomNumber1);
    setLuckyNumber2(randomNumber2);
  
    const q1 = getData("vid", randomNumber1)[0]; // Use randomNumber1 directly here
    const q2 = getData("vid", randomNumber2)[0]; // Use randomNumber2 directly here
    setQuestion1(q1);
    setQuestion2(q2);
    localStorage.setItem("q1", randomNumber1);
    localStorage.setItem("q2", randomNumber2);
  
    setTimeout(() => {
      setSpinning(false);
      setNumShow(true);
  
      try {
        localStorage.setItem("questions", JSON.stringify({ q1: q1, q2: q2 }))
      } catch (error) {
        console.log(error)
      }
  
    }, 2000);
  };

  const goToDashboard =()=>{
    localStorage.setItem("takens", []);
    navigate('/dashboard');
  }

 var questionNumbers = [
    {id:1,label:"أ"},
    {id:2,label:"ب"},
    {id:3,label:"ت"},
    {id:4,label:"ث"},
    {id:5,label:"ج"},
    {id:6,label:"ح"},
    {id:7,label:"خ"},
    {id:8,label:"د"},
    {id:9,label:"ذ"},
    {id:10,label:"ر"},
    {id:11,label:"ز"},
    {id:12,label:"س"},
    {id:13,label:"ش"},
    {id:14,label:"ص"},
    {id:15,label:"ض"}
  ];

  //let takens = [1,3];
  useEffect(() => {
    // Retrieve takens array from local storage
    const storedTakens = localStorage.getItem('takens');
    if (storedTakens) {
      setTakens(JSON.parse(storedTakens));
    }
  }, []);

  const handleClick=(e)=>{
    console.log(e.target.id)
    if(takens.includes(e.target.id)){
    } else {
      if (!takens.includes(e.target.id)) {
        // Add button's ID to the takens array
        takens.push(e.target.id);
        localStorage.setItem('takens', JSON.stringify(takens));
        generateRandomNumbers();
      }
    }
  }
  
 

  return (<>
    {/* {JSON.stringify(takens)} */}
    <div className='h-auto'>
      <div className='text-center mt-2 pb-1 text-white bg-green-800 ring-2 ring-black rounded-full flex justify-around'>
        <span className='mt-2'><button onClick={goToDashboard}><BsBack size={30} /></button></span>
        <span>Participant: <h3 className='bg-violet-800 ring-1 ring-white rounded-full px-2'>{localStorage.getItem("student")}</h3></span>
        <span>Class: <h3 className='bg-violet-800 ring-1 ring-white rounded-full px-2'>{localStorage.getItem("grade")}</h3></span>
        <span>Gofi: <h3 className='bg-violet-800 ring-1 ring-white rounded-full px-2'>{localStorage.getItem("gofi")}</h3></span>
      </div>

      {!numShow && <section dir='rtl' className='mt-5 '>
      <div className=" grid grid-cols-5 gap-3 align-top m-6 lg:text-6xl">
        {questionNumbers?.map((f, i) => (
          <div key={i}>
            <button id={f?.id} disabled={takens.includes(f.id.toString())} className={`${takens?.includes(f.id.toString()) ? "bg-gray-400" : "bg-green-200 hover:bg-green-700 hover:text-white"} text-3xl arabic rounded-2xl w-20 p-2`} onClick={handleClick} >{f?.label}</button>
          </div>

        ))}
      </div>
      {spinning && <Loading />}
      </section>}

      <div className='text-center mt-5'>
        {/* <button className='getrandombtn bg-green-900 text-white rounded-full p-2' onClick={generateRandomNumbers} disabled={spinning}>
          {spinning ? <Loading /> : "Get Random Questions"}
        </button> */}
        <section>
          {spinning && <div></div>}
          <div>
            {numShow && question1?.vid !== undefined && (
              <div>
                <div className='flex justify-around mt-5 mb-3 arabic' >
                  <div>
                    <h1 className='dhivehi'>ފުރަތަމަ ސުވާލު</h1>
                    {/* <AnimatedNumber targetNumber={luckyNumber1} /> */}
                    <div className='m-2 animated-number text-white bg-black p-1 rounded-lg'>{question1?.vid}</div>
                    <div className='text-2xl'> <span>سورة </span> {question1?.sura_name_ar}</div>
                    <h3 className='text-2xl'>Page: {question1?.page}</h3>
                    <div className='text-2xl'><span>الآية: </span><span>{question1?.aya_number}</span></div>

                  </div>
                  <div>
                    <h1 className='dhivehi'>ދެވަނަ ސުވާލު</h1>
                    {/* <AnimatedNumber2 targetNumber={luckyNumber2} />  */}
                    <div className='m-2 animated-number text-white bg-black p-1 rounded-lg'>{question2?.vid}</div>
                    <div className='text-2xl'> <span>سورة </span> {question2?.sura_name_ar} </div>
                    <h3 className='text-2xl'>Page: {question2?.page}</h3>
                    <div className='text-2xl'><span>الآية: </span><span>{question2?.aya_number}</span></div>

                  </div>


                </div>
              </div>
            )}
          </div>
        </section>
      </div>


      <div className=" grid grid-cols-7 gap-2 align-top m-6">
        {/* {filter?.map((f, i) => (
          <div key={i}>
            <QuestionNumber onClick={handleClick} id={f} qn={f} />
          </div>

        ))} */}
      </div>


      {numShow && question1?.vid !== undefined &&  <div className='flex justify-center'>
        <Link to={"/q1"} className='cursor-pointer hover:text-3xl'><div className='bg-green-900 hover:bg-indigo-800 text-white rounded-full p-2'>START</div></Link>
      </div>}
    </div> </>
  )
}

export default Questions;
